import { useNavigate } from "react-router";
import "./Footer.css";

export default function Footer() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/contact");
    }
    return (
        <footer className="footer">
            <div className="footerCompanyName">
                <h3>Quaking Aspen 3D Printing</h3>
                <p>Premium fantasy prints for tabletop gamers and collectors.</p>
            </div>
            <ul className="socials">
                <a href="https://www.facebook.com/profile.php?id=61573309960736"><li>Facebook</li></a>
                <a href="https://www.instagram.com/qa3dprints/"><li>Instagram</li></a>
                {/* <a><li>Bluesky</li></a> */}
                <li onClick={handleClick}>Contact</li>
            </ul>
        </footer>
    )
}